import React, { Component, useEffect } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import OtherTextInput from '../Components/layout/OtherTextInput';
import { PLATFORM_BUTTONS } from './ConstPlatformBtns';
import { OTHER_CKBX_VAL, isOtherChecked } from './OtherCheckboxUtils';

const PLATFORMS_HELP = `
  <div>
    <p><strong>Purpose:</strong> We ask about platforms so that you’ll have a heads up about whether your client needs to access a particular platform or device.  
    Not every access method works with every platform.  
    And there is usually some variation in available access features across different platforms.</p>
    <p>If the client absolutely must use a specific platform for a specific reason, try to have that platform / device available to keep the assessment as close to the real-world setup as possible. </p>
    <p>If your client doesn’t know yet what platforms or devices they’ll need to use, that’s fine.  You can just start with a device they already have, or one that you know is a good fit for the activities they want to do.</p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  platforms: PropTypes.arrayOf(PropTypes.string),
  onChangePlatforms: PropTypes.func.isRequired,
  saveFormData: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  platforms: []
};

//content sub-component with unique content for this page
class GoalsPlatformsContent extends Component {
  constructor(props){
    super(props);
    this.validate = this.validate.bind(this);
  }

  validate(){
  }

  //Render the form for the main goal.
  //Calls the setter that's passed in by the parent, when a checkbox is clicked.
  //That setter changes the state of the mainGoal in the parent, 
  //which triggers a new render of the view with the new goal.

  //TODO: group these into categories, e.g., to leave a blank line between types of devices as in the wireframe
  render(){
    const platforms = this.props.platforms ?? [];
    const onChangePlatforms= this.props.onChangePlatforms;
    console.log("rendering GatherInfoGoalsPlatforms with platforms: " + platforms);
    const otherPlatform = this.props.otherPlatform;
    const onChangeOtherPlatform = this.props.onChangeOtherPlatform;

    let activeBtns = PLATFORM_BUTTONS; 
    let otherChecked = isOtherChecked(platforms);

    //Temporary fallback to make sure we always have some buttons

    return(
    <>
    <Form>
      <FormGroup tag="fieldset">
        <legend>Check all that apply:</legend>
        {activeBtns.map((btn, index) =>
          <React.Fragment key={index}>
          <FormGroup check>
            <Input
              id={btn.value}
              value={btn.value}
              checked={platforms.findIndex( (platform) => platform.startsWith(btn.value)) > -1}
              onChange={onChangePlatforms} 
              name="platforms"
              type="checkbox"
            />
            {' '}
            <Label for={btn.value} check>
              {btn.label}
              {' '}
              <span className="aa-more-info">{btn.moreInfo}</span>
            </Label>
          </FormGroup>
          {/* If the btn is 'other', include a text field to specify */}
          { ((btn.value === OTHER_CKBX_VAL)) 
            ?
            <OtherTextInput
              otherChecked={otherChecked}
              otherText={otherPlatform}
              onChangeOtherText={onChangeOtherPlatform}
            />
          : null
          }
          </React.Fragment>
        )}
      </FormGroup>
    </Form>
    </>
  );
}
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component.
//since the main goal step includes a form, receive the initial form values via props,
//along with setters to change those values based on the form input.
function GatherInfoGoalsPlatforms(props) {
  const firstName = props.firstName;
  const pronouns = props.pronouns;
  let verb = "needs";
  if (pronouns[0] === defaultProps.pronouns[0])
    verb = "need";  

  const platforms = props.platforms;
  const onChangePlatforms = props.onChangePlatforms;
  const otherPlatform = props.otherPlatform;
  const onChangeOtherPlatform = props.onChangeOtherPlatform;
  const saveFormData = props.saveFormData;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoGoalsPlatforms, platforms: " + platforms);

  const pageData = {
    image: "", //not yet used
    faIcon: "", //"fa-bullseye",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Are there specific devices that ${firstName} wants or needs to use?`,
    subTitle: `If ${firstName} has particular types of devices that ${pronouns[0]} ${verb} to access, mark those here. 
      If the specific type doesn't matter, you can leave this blank.`,
    learnMore: {linkText: "Learn More about why we ask about platforms",
                title: "Platforms",
                content: PLATFORMS_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  useEffect(() => {
    console.log('GIGPlatforms mounted');
    return () => {
      console.log('GIGPlatforms unmounting and saving...');
      saveFormData();
    }
  }, [saveFormData])

  return(
    <>
    <Body page={pageData} 
      contentComponent={
        <GoalsPlatformsContent 
          platforms={platforms} 
          onChangePlatforms={onChangePlatforms}
          otherPlatform={otherPlatform}
          onChangeOtherPlatform={onChangeOtherPlatform}
        />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoGoalsPlatforms.propTypes = propTypes;
GatherInfoGoalsPlatforms.defaultProps = defaultProps;

export default GatherInfoGoalsPlatforms;